import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { Allocation, AllocationFormType, AllocationSummary, CreateAllocation, GetAllocationsFilter, UpdateAllocation } from '../models/allocation';
import { environment } from '../../../environments/environment';
import { Guid } from 'guid-typescript';
import { BudgetPlan } from '../models/submission';
import { AllocationStatus } from '../enums/allocation-status';

@Injectable({
  providedIn: 'root'
})
export class AllocationService {

  private baseUrl = `${environment.apiUrl}/allocations`;

  constructor(private http: HttpClient) {}

  createAllocation(createAllocationDto: CreateAllocation): Observable<string> {
    return this.http.post<string>(`${this.baseUrl}`, createAllocationDto);
  }

  updateAllocation(updateAllocationDto: UpdateAllocation): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}`, updateAllocationDto);
  }

  deleteAllocation(id: Guid): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  changeStatus(id: Guid, targetStatus: AllocationStatus): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}/status`, { targetStatus });
  }

  getAllocations(filter: GetAllocationsFilter): Observable<AllocationSummary[]> {
    let url = `${this.baseUrl}`;
    const params = filter.toQueryParams();
  
    return this.http.get<AllocationSummary[]>(url, { params });
  }

  getAllocation(id: Guid): Observable<Allocation> {
    return this.http.get<Allocation>(`${this.baseUrl}/${id}`).pipe(
      map((allocation) => {  
        allocation.budgetPlan = BudgetPlan.fromJson(allocation.budgetPlan); 
        return allocation;
      }));
  }

  downloadForms(allocationId: Guid, formTypes: AllocationFormType[]): Observable<Blob> {
    let params = new HttpParams();
    
    formTypes.forEach(ft => {
      params = params.append('formTypes', ft.toString());
    });
  
    const url = `${this.baseUrl}/${allocationId}/forms`;
    return this.http.get(url, { params, responseType: 'blob' });
  }
}
